/* global Cookies */
const banner = document.getElementById('site-banner-top');
const closeBtn = banner.querySelector('#site-banner-top-close');

const hideBanner = (event) => {
  event.preventDefault();
  banner.style.display = 'none';
  document.documentElement.classList.remove('has-banner-top');
  Cookies.set('bannerDissmissal', 'true', {expires: 7});
};

const init = () => {
  // Don't show if cookie is set
  if (Cookies.get('bannerDissmissal') == 'true') {
    banner.style.display = 'none';
    return;
  }

  if (banner) {
    banner.classList.add('is-visible');
    document.documentElement.classList.add('has-banner-top');
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', hideBanner);
  }
};

init();
